import { useEffect, useState } from "react";
import { CityEscapeMatchOverviewTable } from "../components/CityEscapeMatchOverviewTable/CityEscapeMatchOverviewTable";
import { ChallengeEventTypes } from "../directus/collections";
import { MatchEnigmaIds } from "../services/enigmaStats.service";
import { OpenModalProps, useDialog } from "./DialogProvider";
import { CityEscapeMatchesList } from "../components/CityEscapeMatchesList.component";
import { MatchFilter } from "../libs/statsFilters";
// export type OpenModalProps = {
//   title?: string;
//   highlightColumns?: MatchEventType[];
//   data?: MatchEnigmaIds[];
//   loading?: boolean;
// };

// export type CityEscapeMatchOverviewDialogProviderContextType = {
//   openModal: (props: OpenModalProps) => void;
//   close: () => void;
//   setLoading: (loading: boolean) => void;
//   setData: (data: MatchEnigmaIds[]) => void;
// };

// export const CityEscapeMatchOverviewDialogProviderContext = createContext<
//   CityEscapeMatchOverviewDialogProviderContextType | undefined
// >(undefined);

// export function CityEscapeMatchOverviewDialogProvider({
//   children,
//   matchesMap,
//   cityEscapeId,
// }: {
//   children: React.ReactNode;

//   cityEscapeId?: string;
// }) {
//   const [modalOpen, setModalOpen] = useState(false);
//   const [modalConfigs, setModalConfigs] = useState<{
//     title?: string;
//     highlightColumns?: MatchEventType[];
//   } | null>(null);

//   const [loading, setLoading] = useState(false);
//   const [data, setData] = useState<MatchEnigmaIds[] | null>(null);

//   const openDialog = ({
//     title,
//     highlightColumns,
//     loading,
//     data,
//   }: OpenModalProps) => {
//     console.log("opening dialog");
//     setModalConfigs({ title, highlightColumns });
//     setModalOpen(true);
//     setLoading(Boolean(loading));
//     if (data) setData(data);
//   };

//   const closeDialog = () => {
//     setModalOpen(false);
//     setModalConfigs(null);
//   };

//   return (
//     <CityEscapeMatchOverviewDialogProviderContext.Provider
//       value={{ openModal: openDialog, close: closeDialog, setLoading, setData }}
//     >
//       {children}
//       <Dialog
//         open={modalOpen}
//         onClose={closeDialog}
//         aria-labelledby="parent-modal-title"
//         aria-describedby="parent-modal-description"
//         maxWidth={"lg"}
//       >
//         <DialogTitle
//           display={"flex"}
//           justifyContent="space-between"
//           width={"100%"}
//         >
//           <span>
//             Informazioni segmento partite: <b>{modalConfigs?.title}</b>
//             {data ? `(${Object.keys(data).length})` : `(0)`}
//           </span>
//           <IconButton
//             edge="start"
//             color="inherit"
//             onClick={closeDialog}
//             aria-label="close"
//           >
//             <CloseIcon />
//           </IconButton>
//         </DialogTitle>
//         <DialogContent>
//           <LoadingGuard isLoading={loading}>
//             {/* <Box maxHeight={"70vh"} overflow={"auto"}> */}
//             {modalConfigs && data && (
//               // <CityEscapeMatchOverviewTable
//               //   challengeId={challengeId ?? ""}
//               //   data={data}
//               //   columns={ChallengeEventTypes}
//               //   highlightColumns={modalConfigs.highlightColumns}
//               //   totalCount={data.length}
//               //   sx={{ maxHeight: "70vh" }}
//               // />
//               <CityEscapeMatchesList cityEscapeId={cityEscapeId} data={data} highlightColumns={modalConfigs.highlightColumns} />

//             )}
//             {/* </Box> */}
//           </LoadingGuard>
//         </DialogContent>
//       </Dialog>
//     </CityEscapeMatchOverviewDialogProviderContext.Provider>
//   );
// }

// export function useCityEscapeMatchOverviewDialog() {
//   const context = useContext(CityEscapeMatchOverviewDialogProviderContext);
//   if (!context) {
//     throw new Error(
//       "useCityEscapeMatchOverviewDialog must be used within a CityEscapeMatchOverviewDialogProvider"
//     );
//   }
//   return context;
// }

export type CityEscapeMatchOverviewOpenModalProps = {
  title?: string;
  filters?: MatchFilter;
  loading?: boolean;
  cityEscapeId?: string;
};

function CityEscapeMatchOverviewDialogTitle(
  props: CityEscapeMatchOverviewOpenModalProps
) {
  return (
    <span>
      Partite: <b>{props.title}</b>
    </span>
  );
}

function CityEscapeMatchOverviewDialogContent(
  props: CityEscapeMatchOverviewOpenModalProps
) {
  return (
    <CityEscapeMatchesList  
      cityEscapeId={props.cityEscapeId}
      filters={props.filters}
    />
  );
}

export function useCityEscapeMatchOverviewDialog(id?: string) {
  const dialog = useDialog();
  const dialogId = id ?? "city-escape-match-overview-dialog";
  const [props, setProps] =
    useState<CityEscapeMatchOverviewOpenModalProps | null>(null);

  useEffect(() => {
    const startingProps: OpenModalProps = {
      loading: true,
      slotProps: { dialog: { maxWidth: "lg" } },
    };

    dialog.create(dialogId, startingProps, { onConflict: "replace" });
  }, []);

  const openModal = (props: CityEscapeMatchOverviewOpenModalProps) => {
    console.log("opening dialog", props);

    dialog.open(dialogId, {
      loading: props.loading,
      title: <CityEscapeMatchOverviewDialogTitle {...props} />,
      content: <CityEscapeMatchOverviewDialogContent {...props} />,
      slotProps: { dialog: { maxWidth: "lg" } },
    });

    setProps(props);
  };

  const close = () => {
    dialog.remove(dialogId);
  };

  const setLoading = (loading: boolean) => {
    dialog.update(dialogId, (props) => ({ ...props, loading }));

    setProps((prev) => {
      if (!prev) {
        throw new Error(
          "Dialog" + dialogId + " not opened yet. Cannot set loading."
        );
      }
      return { ...prev, loading };
    });
  };

  const setData = (data: MatchEnigmaIds[]) => {
    const updatedProps = { ...(props ?? {}), data };

    dialog.update(dialogId, (prev) => ({
      ...prev,
      loading: false,
      title: <CityEscapeMatchOverviewDialogTitle {...updatedProps} />,
      content: <CityEscapeMatchOverviewDialogContent {...updatedProps} />,
    }));

    setProps(updatedProps);
  };

  return {
    openModal,
    close,
    setLoading,
    setData,
  };
}
